/**
 * Resource error severity classification strategy
 */

import type { SeverityStrategy, ErrorContext } from './SeverityStrategy.js';
import type { Severity } from '../../types.js';

export class ResourceErrorSeverity implements SeverityStrategy {
  canHandle(context: ErrorContext): boolean {
    return context.type === 'resource';
  }

  classify(context: ErrorContext): Severity {
    const url = context.url || '';

    // HIGH: Critical resources (scripts, stylesheets) that break functionality
    if (url.includes('.js') || url.includes('.css')) {
      return 'high';
    }

    // MEDIUM: Images and fonts that affect UX
    if (
      url.match(/\.(jpg|jpeg|png|gif|webp|svg|ico)$/i) ||
      url.match(/\.(woff|woff2|ttf|otf|eot)$/i)
    ) {
      return 'medium';
    }

    // LOW: Other resources
    return 'low';
  }
}

